import React, {useEffect, useState} from 'react'
import {getSingleTag, searchTags} from "../common/services/tag-data-service";
import {TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'

const TagList = ({selectedTag, setSelectedTag, selectedTagRemoved, setSelectedTagRemoved}) => {
    const [searchText, setSearchText] = useState('');
    const [tagsList, setTagsList] = useState([]);

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const handleSelectTag = async (tag) => {
        const existingTag = await getSingleTag(tag.id);
        const tagData = existingTag.data();
        tagData.id = existingTag.id;

        setSelectedTag(tagData);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                const tagsListResult = await searchTags(searchText);
                setTagsList(tagsListResult);
                setSelectedTag(tagsListResult[0]);
            }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchText]);

    useEffect(() => {
        if (selectedTagRemoved) {
            let currentTagsList = [...tagsList];
            currentTagsList = _.filter(currentTagsList, tag => {
                return tag.id !== selectedTag.id;
            });

            setTagsList(currentTagsList);
            setSelectedTag(currentTagsList[0]);
            setSelectedTagRemoved(false);
        }
    }, [selectedTagRemoved]);

    return (
        <>

            <div className="mb-2 flex justify-between">
                <input type="text" placeholder="Search"
                       id="text"
                       name="text"
                       value={searchText}
                       onChange={handleSearchText}
                       className="h-12 w-full border border-gray-500 p-4 rounded mr-2"/>

                <button
                    onClick={() => handleClearSearch()}
                    className="rounded flex items-center justify-center border-gray-500 border bg-white text-gray-500 h-12 hover:bg-gray-500 hover:text-white">
                    <div className="p-4">
                        <TrashIcon className="h-6 w-6"/>
                    </div>
                </button>
            </div>

            <div
                className="overflow-y-scroll h-full border border-gray-400 bg-white px-4">
                <div className="py-4">
                    {tagsList?.map((tag, index) => (
                        <div key={index}
                             className={`h-10 w-full li-item ${selectedTag?.id === tag?.id ? 'li-item-selected' : ''}`}
                             onClick={() => {
                                 handleSelectTag(tag)
                             }}>
                            <div className="pt-2">
                                <span className="px-4">{index + 1}</span>{tag.startText}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </>
    )
}

export default TagList
